import { Extension } from '@tiptap/core';

const TARGET_TYPES = ['paragraph', 'heading', 'listItem'];

const normalizeLineHeight = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return null;
  const clamped = Math.max(0.8, Math.min(3, numeric));
  return Math.round(clamped * 100) / 100;
};

const parseLineHeight = (element) => {
  const dataValue = element?.getAttribute?.('data-line-height');
  const styleValue = element?.style?.lineHeight;
  const raw = dataValue || styleValue || '';
  if (!raw) return null;
  const match = String(raw).match(/-?\d+(\.\d+)?/);
  if (!match) return null;
  return normalizeLineHeight(match[0]);
};

const setLineHeightForSelection = (state, dispatch, lineHeight) => {
  const { from, to, empty } = state.selection;
  const targetTypes = TARGET_TYPES
    .map((name) => state.schema.nodes[name])
    .filter(Boolean);
  if (!targetTypes.length) return false;

  let tr = state.tr;
  let changed = false;
  const isTargetType = (type) => targetTypes.some((targetType) => targetType === type);

  state.doc.nodesBetween(from, to, (node, pos) => {
    if (!isTargetType(node.type)) return;
    tr = tr.setNodeMarkup(pos, node.type, { ...node.attrs, lineHeight }, node.marks);
    changed = true;
  });

  if (!changed && empty) {
    const { $from } = state.selection;
    for (let depth = $from.depth; depth > 0; depth -= 1) {
      const node = $from.node(depth);
      if (!isTargetType(node.type)) continue;
      const pos = $from.before(depth);
      tr = tr.setNodeMarkup(pos, node.type, { ...node.attrs, lineHeight }, node.marks);
      changed = true;
      break;
    }
  }

  if (!changed) return false;
  if (dispatch) dispatch(tr);
  return true;
};

const LineHeightExtension = Extension.create({
  name: 'lineHeight',

  addGlobalAttributes() {
    return [
      {
        types: TARGET_TYPES,
        attributes: {
          lineHeight: {
            default: null,
            parseHTML: parseLineHeight,
            renderHTML: (attributes) => {
              const value = normalizeLineHeight(attributes?.lineHeight);
              if (value === null) return {};
              return {
                style: `line-height: ${value};`,
                'data-line-height': String(value),
              };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setLineHeight:
        (value) =>
        ({ state, dispatch }) =>
          setLineHeightForSelection(state, dispatch, normalizeLineHeight(value)),
      unsetLineHeight:
        () =>
        ({ state, dispatch }) =>
          setLineHeightForSelection(state, dispatch, null),
    };
  },
});

export default LineHeightExtension;
